<template>
    <div id="auth">
      <v-divider />
      <v-img 
        id='banner-top' 
        :src=bannerImg 
        gradient="to right, rgba(255,255,255,0.95), rgba(255,255,255,.7)"
      >
        <div id="signup-text"> 
          <span class="display-1 primary_dark--text">{{newUser ? "Let's get started!" : "It's great to see you!"}}</span><br><br>
          <span class="headline primary_lighter--text">{{newUser ? "Sign up using your phone or email." : "Sign in to see your account."}}</span>
        </div>
        <!-- Sign in with phone -->
        <AuthCardPhone 
          v-if="type == 'phone'"
          :newUser="newUser"
          onSuccessPath="/account"
          :colorFrontMain="$vuetify.theme.themes.light.tertiary" 
          :colorFrontLight="$vuetify.theme.themes.light.tertiary_light"
          :colorBackMain="$vuetify.theme.themes.light.secondary"
          :colorBackLight="$vuetify.theme.themes.light.secondary_light"
          class="signup-panel" />
          <!-- Else sign in with email -->
        <AuthCardEmail
          v-else
          :newUser="newUser"
          onSuccessPath="/account"
          :colorFrontMain="$vuetify.theme.themes.light.tertiary" 
          :colorFrontLight="$vuetify.theme.themes.light.tertiary_light"
          :colorBackMain="$vuetify.theme.themes.light.secondary"
          :colorBackLight="$vuetify.theme.themes.light.secondary_light"
          class="signup-panel" />
      </v-img>
      <v-divider style="margin-bottom:10vh;"/>
    </div>
</template>

<script>

import {
  mapGetters
} from 'vuex'

import { mask } from 'vue-the-mask'

import { firebase } from '@/utils/firebase'

export default {
  name: 'signup',
  directives: {
    mask,
  },
  data () {
      return {
      }
  },
  mounted() {

    // this.makeRecaptcha()
      // this.$store.commit('SET_PAGE_TITLE', '')
      // this.$scrollTo('#app', 200, {easing: 'linear'})
      
      // console.log(this.$route)
      // let invite = this.$localStorage.get('invite')
      // this.$store.commit('SET_INVITE', invite)
      // console.log(`Recovered Invite: ${invite}`)
  
  },
  computed: {
    ...mapGetters({
        debug: 'getDebug',
        loading: 'getLoading',
    }),
    type: function () {
      return this.$route.params.type ? this.$route.params.type : 'phone'
    },
    newUser: function () {
      return this.$route.params.new == 'true' 
    },

  },
  methods: {
  }
}
</script>

<style scoped>

#auth {
  width: 100%;
  align-content: center;
  position: relative;
}

#banner-top {
  border-style: solid;
  border-width: 2px;
  border-color: #aaaaaa;
}

.signup-panel {
  width: 40%;
  height: auto;


  position: absolute;
  top: 50%;
  left: 80%;
  margin-right: -20%;
  transform: translate(-50%, -50%);

  text-align: center;
}

#signup-text {
  width: 40%;
  height: auto;


  position: absolute;
  top: 30%;
  left: 25%;
  margin-right: -80%;
  transform: translate(-50%, -50%);

  text-align: center;
}


</style>



